import { Link, useParams, Navigate } from "react-router-dom";
import SEOHead from "@/components/SEOHead";
import SEOPageLayout from "@/components/SEOPageLayout";
import { getPostBySlug } from "@/data/blogPosts";
import POST_DESIGN from "@/data/posts/designCustomRugbyUniformsNZ";
import POST_BEST from "@/data/posts/bestCustomUniformsRugbyAuckland";
import POST_SUB from "@/data/posts/sublimationVsDTF";
import POST_REUNION from "@/data/posts/pacificFamilyReunionChecklist";

const POST_CONTENT = {
  "design-custom-rugby-uniforms-nz": POST_DESIGN,
  "best-custom-uniforms-rugby-auckland": POST_BEST,
  "sublimation-vs-dtf-printing": POST_SUB,
  "pacific-family-reunion-polo-shirt-checklist": POST_REUNION,
};

const POST_HERO_IMG = {
  "design-custom-rugby-uniforms-nz":
    "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  "best-custom-uniforms-rugby-auckland":
    "https://images.pexels.com/photos/9799205/pexels-photo-9799205.jpeg?auto=compress&cs=tinysrgb&w=1600",
  "sublimation-vs-dtf-printing":
    "https://images.unsplash.com/photo-1773525912476-213bff96b8a4?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  "pacific-family-reunion-polo-shirt-checklist":
    "https://customer-assets.emergentagent.com/job_custom-team-jerseys-1/artifacts/l8dmj7l0_The%20Ultimate%20Polo%20Shirt%20Checklist.png",
};

export default function BlogPost() {
  const { slug } = useParams();
  const meta = getPostBySlug(slug);
  const Content = POST_CONTENT[slug];

  if (!meta || !Content) return <Navigate to="/blog" replace />;

  const heroImage = POST_HERO_IMG[slug];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: meta.title,
    description: meta.excerpt,
    image: heroImage,
    author: { "@type": "Organization", name: "Tribal Designz" },
    publisher: {
      "@type": "Organization",
      name: "Tribal Designz",
      logo: {
        "@type": "ImageObject",
        url: "https://tribaldesignz.com/logo.png",
      },
    },
    mainEntityOfPage: `https://tribaldesignz.com/blog/${slug}`,
  };

  return (
    <>
      <SEOHead
        title={meta.title}
        description={meta.excerpt}
        path={`/blog/${slug}`}
        image={heroImage}
        jsonLd={jsonLd}
      />
      <SEOPageLayout
        heroEyebrow={`Article · ${meta.readTime}`}
        heroH1={meta.title}
        heroSub={meta.excerpt}
        heroImage={heroImage}
        heroImageAlt={meta.title}
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "Blog", href: "/blog" },
          { label: meta.title },
        ]}
      >
        <Content />
        <hr className="my-10 border-zinc-800" />
        <p className="text-zinc-400">
          <strong>About Tribal Designz</strong> — We're an Auckland-based
          custom apparel studio specialising in{" "}
          <Link to="/custom-rugby-uniforms-nz">custom rugby uniforms</Link>,{" "}
          <Link to="/custom-basketball-jerseys-nz">basketball jerseys</Link>,{" "}
          <Link to="/fast-tshirt-printing-auckland">fast t-shirt printing</Link>{" "}
          and <Link to="/bulk-custom-tshirts-nz">bulk t-shirts</Link> for
          Pasifika, Māori and community teams across New Zealand.
        </p>
      </SEOPageLayout>
    </>
  );
}
